import api from './api';

// ── API Keys ──────────────────────────────────────────────────────────────────
export const getApiKeys = () => api.get('/api-keys');
export const createApiKey = (data) => api.post('/api-keys', data);
export const deleteApiKey = (id) => api.delete(`/api-keys/${id}`);
export const revokeApiKey = (id) => api.post(`/api-keys/${id}/revoke`, {});
export const activateApiKey = (id) => api.post(`/api-keys/${id}/activate`, {});
export const regenerateApiKey = (id, data = {}) => api.post(`/api-keys/${id}/regenerate`, data);
export const revealApiKey = (id, password) => api.post(`/api-keys/${id}/reveal`, { password });
export const setApiKeyExpiry = (id, password, expires_days) =>
    api.post(`/api-keys/${id}/set-expiry`, { password, expires_days });

// ── Bearer Tokens ─────────────────────────────────────────────────────────────
export const getBearerTokens = () => api.get('/bearer-tokens');
export const createBearerToken = (data) => api.post('/bearer-tokens', data);
export const deleteBearerToken = (id) => api.delete(`/bearer-tokens/${id}`);
export const revokeBearerToken = (id) => api.post(`/bearer-tokens/${id}/revoke`, {});
export const activateBearerToken = (id) => api.post(`/bearer-tokens/${id}/activate`, {});
export const revealBearerToken = (id, password) => api.post(`/bearer-tokens/${id}/reveal`, { password });
export const extendBearerToken = (id, password, expires_days) =>
    api.post(`/bearer-tokens/${id}/extend`, { password, expires_days });
